import { Injectable } from '@angular/core';
import { CustomerConfigService } from './customer-config.service';

export enum FeatureType {
  VideoRecordingSaving,
  VoicePlatform,
  VoiceBot,
  EVChargers,
  PowerAutomate,
  Mitte,
  ParkingBase,
  Parkchirp,
  InexLPR,
  Sms,
  StatusPage,
  Axxon,
  Ocra,
  PowerBI,
  WebRtc,
  Acrobits,
  LocationReview,
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private _featuresMap: Map<FeatureType, boolean>;

  public get featuresMap(): Map<FeatureType, boolean> {
    return this._featuresMap;
  }
  constructor(private customerConfigService: CustomerConfigService) {
    this._featuresMap = new Map([
      [FeatureType.Axxon, this.customerConfigService.config.AxxonEnabled],
      [FeatureType.EVChargers, this.customerConfigService.config.EVChargersEnabled],
      [FeatureType.InexLPR, this.customerConfigService.config.InexLPREnabled],
      [FeatureType.Mitte, this.customerConfigService.config.MitteEnabled],
      [FeatureType.ParkingBase, this.customerConfigService.config.ParkingBaseEnabled],
      [FeatureType.Ocra, this.customerConfigService.config.OcraEnabled],
      [FeatureType.Parkchirp, this.customerConfigService.config.ParkchirpEnabled],
      [FeatureType.PowerAutomate, this.customerConfigService.config.PowerAutomateEnabled],
      [FeatureType.PowerBI, this.customerConfigService.config.PowerBIEnabled],
      [FeatureType.Sms, this.customerConfigService.config.SmsEnabled],
      [FeatureType.StatusPage, this.customerConfigService.config.StatusPageEnabled],
      [FeatureType.VideoRecordingSaving, this.customerConfigService.config.VideoRecordingSaving],
      [FeatureType.VoiceBot, this.customerConfigService.config.VoiceBotEnabled],
      [FeatureType.VoicePlatform, this.customerConfigService.config.VoicePlatformEnabled],
      [FeatureType.WebRtc, this.customerConfigService.config.WebRtcEnabled],
      [FeatureType.Acrobits, this.customerConfigService.config.AcrobitsEnabled],
      [FeatureType.LocationReview, this.customerConfigService.config.LocationReviewEnabled],
    ]);
  }

  getFeatureEnabled(feature: FeatureType): boolean {
    const isEnabled = this.featuresMap.get(feature) ?? false;

    return isEnabled;
  }
}
